import SharedChat from 'pages/mobile/Finance/shared/Chat';
import React from 'react';

export interface ChatProps {
  requestId: string;
}

const Chat: React.FC<ChatProps> = ({ requestId }) => (
  <SharedChat requestId={requestId} requestType="factoring" />
);

export default Chat;
